import { coreApi } from '../api'

async function fetchFidcData(applicationId) {
  const { data: response } = await coreApi.get(
    `/loan/auto-refi/bkf/applications/${applicationId}/fidc-application`,
  )

  return {
    id: response.data.id,
  }
}

export { fetchFidcData }
